import React, { useState, useEffect } from 'react'
import EstrellaRating from './EstrellaRating'
import { reviewsService } from '../../services/reviewsService'

const MisCalificaciones = ({ usuarioId }) => {
  const [misReviews, setMisReviews] = useState([])
  const [cargando, setCargando] = useState(true)

  useEffect(() => {
    const cargarDatos = async () => {
      if (usuarioId) {
        try {
          const data = await reviewsService.obtenerReviewsDeUsuario(usuarioId)
          setMisReviews(data)
        } catch (error) {
          console.error('Error cargando mis reviews:', error)
        } finally {
          setCargando(false)
        }
      } else {
        setCargando(false)
      }
    }
    cargarDatos()
  }, [usuarioId])

  if (cargando) return <div style={{padding: '16px', textAlign: 'center'}}>Cargando tus calificaciones...</div>

  if (!usuarioId) {
    return <div style={{textAlign: 'center', padding: '32px'}}>Inicia sesión para ver tus calificaciones</div>
  }

  return (
    <div style={{maxWidth: '800px', margin: '0 auto', padding: '24px'}}>
      <h1 style={{fontSize: '24px', fontWeight: 'bold', marginBottom: '24px'}}>Mis Reviews</h1>
      
      {misReviews.length === 0 ? (
        <div style={{textAlign: 'center', padding: '32px'}}>
          <p style={{color: '#6b7280'}}>No has calificado nada aún.</p>
        </div>
      ) : (
        <div>
          <p style={{color: '#6b7280', marginBottom: '16px'}}>Has calificado {misReviews.length} elementos</p>
          
          {misReviews.map((review) => (
            <div
              key={review.id}
              style={{
                backgroundColor: 'white',
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '16px'
              }}
            >
              {/* Info de la canción con imagen */}
              <div style={{display: 'flex', gap: '12px', marginBottom: '12px'}}>
                {review.entity_image && (
                  <img 
                    src={review.entity_image} 
                    alt={review.entity_name || 'Cover'}
                    style={{
                      width: '60px', 
                      height: '60px', 
                      borderRadius: '6px', 
                      objectFit: 'cover',
                      flexShrink: 0
                    }}
                  />
                )}
                <div style={{flex: 1, minWidth: 0}}>
                  <h4 style={{
                    fontWeight: '600', 
                    marginBottom: '4px', 
                    color: '#111827',
                    fontSize: '16px'
                  }}>
                    {review.entity_name || 'Canción sin nombre'}
                  </h4>
                  {review.entity_artist && (
                    <p style={{fontSize: '14px', color: '#6b7280', marginBottom: '2px'}}>
                      {review.entity_artist}
                    </p>
                  )}
                  {review.entity_album && (
                    <p style={{fontSize: '12px', color: '#9ca3af'}}>
                      {review.entity_album}
                    </p>
                  )}
                  <div style={{marginTop: '8px'}}>
                    <EstrellaRating calificacion={review.rating} soloLectura tamaño="sm" />
                  </div>
                </div>
                <span style={{fontSize: '12px', color: '#6b7280', flexShrink: 0}}>
                  {new Date(review.created_at).toLocaleDateString('es-ES')}
                </span>
              </div>

              {/* Título del review */}
              {review.title && (
                <h5 style={{
                  fontWeight: '600',
                  marginBottom: '8px',
                  color: '#111827',
                  fontSize: '15px'
                }}>
                  "{review.title}"
                </h5>
              )}

              {/* Contenido del review */}
              {review.content && (
                <p style={{
                  color: '#374151',
                  lineHeight: '1.5',
                  fontSize: '14px',
                  backgroundColor: '#f9fafb',
                  padding: '10px',
                  borderRadius: '6px'
                }}>
                  {review.content}
                </p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default MisCalificaciones